import { createApiSlice } from "@common";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CRUD_PROSPECT, CRUD_PROSPECT_ALERT, CRUD_PROSPECT_BY_ID, CRUD_PROSPECT_BY_OWNER, DOWNLOAD_PROSPECT, UPLOAD_PROSPECT } from "@routes";
import axios from "axios";
// Define the API config array
const apiConfig = [
  {
    name: "addProspect",
    method: "post",
    url: CRUD_PROSPECT,
    stateKey: "message",
  },
  {
    name: "getProspect",
    method: "get",
    url: CRUD_PROSPECT,
    stateKey: "data",
  },
  {
    name: "getProspectByOwner",
    method: "get",
    url: CRUD_PROSPECT_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "updateProspect",
    method: "put",
    url: CRUD_PROSPECT,
    stateKey: "message",
  },
  {
    name: "deleteProspect",
    method: "delete",
    url: CRUD_PROSPECT,
    stateKey: "message",
  },
  {
    name: "prospectDeleteAlert",
    method: "get",
    url: CRUD_PROSPECT_ALERT,
    stateKey: "prospectAlertData",
  },
  {
    name: "getProspectDetailsById",
    method: "get",
    url: CRUD_PROSPECT_BY_ID,
    stateKey: "details",
  },
  // {
  //   name: "uploadProspectFile",
  //   method: "post",
  //   url: UPLOAD_PROSPECT,
  //   stateKey: "message",
  // },
];

export const uploadProspectFile = createAsyncThunk(
  "prospect/uploadProspectFile",
  async (formData, { rejectWithValue }) => {
    try {
      const res = await axios.post(UPLOAD_PROSPECT, formData, {
        withCredentials: true,
        responseType: "blob",
      });

      const contentType = res.headers["content-type"];

      // Backend returned an Excel file
      if (
        contentType?.includes(
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        )
      ) {
        const contentDisposition =
          res.headers["content-disposition"];

        // Extract filename from Content-Disposition
        const filenameMatch = contentDisposition?.match(
          /filename\*=(?:UTF-8'')?([^;]+)|filename="?([^";]+)"?/i
        );

        const filename = decodeURIComponent(
          (filenameMatch?.[1] || filenameMatch?.[2] || "")
            .trim()
            .replace(/^"|"$/g, "")
        ) || "ProcessedAndUnprocessed.xlsx";

        const url = globalThis.URL.createObjectURL(
          new Blob([res.data], { type: contentType })
        );

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        globalThis.URL.revokeObjectURL(url);

        return {
          message: "File Processed Successfully",
          filename,
        };
      }

      // Backend returned JSON response as a Blob
      const text = await res.data.text();
      const data = JSON.parse(text);

      return data;
    } catch (err) {
      let errorData = err?.response?.data;

      // Error response can also be a Blob
      if (errorData instanceof Blob) {
        try {
          const text = await errorData.text();
          errorData = JSON.parse(text);
        } catch {
          // Keep original errorData if it is not JSON
        }
      }

      return rejectWithValue(errorData);
    }
  }
);

export const downloadProspectData = createAsyncThunk(
  "prospect/downloadProspectData",
  async (data, { rejectWithValue, dispatch }) => {
    try {
      console.log("Downloading prospect data with params:", data);
      await axios
        .get(DOWNLOAD_PROSPECT, {
          params: data,
          withCredentials: true,
          responseType: "blob",
        })
        .then((res) => {
          const url = globalThis.URL.createObjectURL(new Blob([res.data]));

          const link = document.createElement("a");

          link.href = url;

          link.setAttribute("download", "Prospects.xlsx");

          document.body.appendChild(link);

          link.click();
        });
    } catch (err) {
      return rejectWithValue(err.response);
    }
  }
);
// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    data: [],
    details: [],
    prospectAlertData: [],
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    [downloadProspectData.pending]: (state) => {
      state.loading = true;
    },

    [downloadProspectData.fulfilled]: (state) => {
      state.loading = false;
    },

    [downloadProspectData.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage = action?.payload?.data?.message;
    },
    [uploadProspectFile.pending]: (state) => {
      state.loading = true;
    },

    [uploadProspectFile.fulfilled]: (state, action) => {
      state.loading = false;
      state.message = action.payload?.message;
    },

    [uploadProspectFile.rejected]: (state, action) => {
      state.loading = false;
      state.errMessage =
        action?.payload?.message ||
        action?.payload?.data?.message;
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "prospect",
  apiConfig,
  customReducers,
);
const prospectSlice = slice;

// Export the slice's reducer
export default prospectSlice.reducer;

// Export thunks
export const {
  addProspect,
  getProspect,
  getProspectByOwner,
  updateProspect,
  deleteProspect,
  getProspectDetailsById,
  prospectDeleteAlert,
  // uploadProspectFile
} = thunks;

// Export actions
export const { rowSelect } = actions;
